import { useAppDispatch } from "../../../../store/store";
import CloseIcon from "../../../../assets/icons/builderClose.svg";
import { setCampaingBuilderSideBarClose } from "../../../../store/features/common";
import { useTranslation } from "react-i18next";

export const CampaignBuilderSideNavCloseBtn = ({
  setIsOpenAiChat,
}: {
  setIsOpenAiChat: React.Dispatch<boolean>;
}) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const handleCloseSideBar = () => {
    dispatch(setCampaingBuilderSideBarClose());
    setIsOpenAiChat(true);
  };
  return (
    <div
      onClick={handleCloseSideBar}
      className="campaign-builder-sidenav-close"
      style={{
        transform: i18n.dir() === "rtl" ? "scaleX(-1)" : "scaleX(1)",
      }}
    >
      <img src={CloseIcon} />
    </div>
  );
};
